import { InvestmentState } from "./types";
import { VOID_STATES } from "./stateGroups";

/** These lists describe the legacy UI, not the backend transition permissions. */
export const INVESTMENT_FILTER_STATES = Object.values(InvestmentState);
export const INVESTMENT_FORM_STATES = [
  InvestmentState.PROSPECT,
  InvestmentState.RESERVED,
  InvestmentState.FINANCING,
  InvestmentState.FUNDED,
  InvestmentState.DECLARED,
  InvestmentState.REJECTED,
] as const;
export const INVESTMENT_STAGE_STATES = INVESTMENT_FORM_STATES.filter(
  (state) => state !== InvestmentState.REJECTED,
);
interface InvestmentStageGroup {
  id: string;
  state: InvestmentState;
  states?: InvestmentState[];
}
export const INVESTMENT_KANBAN_GROUPS: InvestmentStageGroup[] = INVESTMENT_FORM_STATES.map(
  (state) => ({
    id: state,
    state,
    ...(state === InvestmentState.REJECTED ? { states: [...VOID_STATES] } : {}),
  }),
);

export function isInvestmentCorrectionMode(
  investment: { state: InvestmentState } | null | undefined,
): boolean {
  return !!investment && investment.state !== InvestmentState.PROSPECT;
}
export function isRejectedInvestmentStage(state: InvestmentState): boolean {
  return VOID_STATES.has(state);
}
export function getInvestmentFiscalYearOptions(currentYear: number): number[] {
  return Array.from({ length: 5 }, (_, index) => currentYear - index);
}
export function getInvestmentKanbanColumnId(state: InvestmentState): string {
  return (
    INVESTMENT_KANBAN_GROUPS.find((column) =>
      column.states ? column.states.includes(state) : column.state === state,
    )?.id ?? ""
  );
}
export function getInvestmentDropState(columnId: string): InvestmentState {
  return (
    INVESTMENT_KANBAN_GROUPS.find((column) => column.id === columnId)?.state ??
    InvestmentState.REJECTED
  );
}

export function getPostContractTransition(contract: "reservation" | "financing") {
  return contract === "reservation"
    ? { targetState: InvestmentState.RESERVED, eligibleStates: [InvestmentState.PROSPECT] }
    : {
        targetState: InvestmentState.FINANCING,
        eligibleStates: [InvestmentState.PROSPECT, InvestmentState.RESERVED],
      };
}
